import {createFileRoute, redirect} from '@tanstack/react-router';
import Cookies from 'universal-cookie';
import {LOGIN} from '@/anonymous/routing/paths';
import {REDIRECT_TO} from '@/shared/const/cookies';
import type {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/')({
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isLoggedIn) {
      const cookies = new Cookies();
      let redirectTo = cookies.get(REDIRECT_TO) ?? USER_HOME;

      if (redirectTo === LOGIN) {
        redirectTo = USER_HOME;
      }

      cookies.remove(REDIRECT_TO);
      throw redirect({to: redirectTo, replace: true});
    }

    throw redirect({to: LOGIN, replace: true});
  }
});
